import {useQueryModal} from "@/hooks/useQueryModal.ts";
import {useTableQuery} from "@/hooks/useTableQuery.ts";
import {SortField, useNewsByTagSlug} from "@/hooks/useNews.ts";
import {HeroHeader} from "@/components/HeroHeader.tsx";
import NewsGrid from "@/components/NewsGrid.tsx";
import {useTagBySlug} from "@/hooks/useTags.ts";
import {MetaTags} from "@/hooks/MetaTags.tsx";


export default function OnAirNewsPage() {
    const slug = "opie-lug";
    const {searchParams, setParam} = useQueryModal();

    const {page, size, setPage} = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 12,
        defaultSortBy: "publishedAt",
        defaultSortOrder: "desc",
    });

    const {
        data: result,
        isLoading: isLoading,
        isError: isError,
    } = useNewsByTagSlug(slug, {
        page: page,
        size: size,
        sortBy: "publishedAt",
        sortOrder: "desc",
    });

    const {data: tag, isLoading: isLoadingTag, isError: isErrorTag,} = useTagBySlug(slug);

    return (
        <>
            <MetaTags
                title={"Kosmos 94.1 - Op die Lug Nuus"}
                description={"Nuus vanaf die Kosmos 94.1 se lugprogramme"}
                url={"/nuus/op-die-lug"}
            />

            <HeroHeader
                title={isLoadingTag || isErrorTag ? "Op die Lug Nuus" : tag?.name}
                subtitle={isLoadingTag || isErrorTag ? "Nuus vanaf die Kosmos 94.1 se lugprogramme" : tag?.description}
                imageAlt={slug}/>

            <section className="py-16 sm:py-22">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">

                    <NewsGrid
                        content={result}
                        isLoading={isLoading}
                        isError={isError}
                        seeMoreDisplay={false}
                        showTags={false}
                        setPage={setPage}
                    />
                </div>
            </section>
        </>
    );
}
